import React from 'react';
import {TableCell} from 'material-ui';
import FaqTranslationsTableItemActionAdd from './FaqTranslationsTableItemActionAdd';
import FaqTranslationsTableItemActionEdit from './FaqTranslationsTableItemActionEdit';
import FaqTranslationsTableItemActionDelete from './FaqTranslationsTableItemActionDelete';
import {
    showAddNewTranslationButton,
    showDeleteTranslationButton,
} from '../../../components/permissions/permissions';

class FaqTranslationsTableItemActions extends React.Component {

    render() {
        const {
            faqTranslation,
            classes,
            handleClick,
            faq,
            site,
            handleClickOpen,
        } = this.props;

        let DeleteTranslationButton = showDeleteTranslationButton(() =>
            <FaqTranslationsTableItemActionDelete
                classes={classes}
                handleClickOpen={handleClickOpen}
                faqTranslation={faqTranslation}
                faqId={faq.id}
            />
        )

        let AddTranslationButton = showAddNewTranslationButton(() =>
            <FaqTranslationsTableItemActionAdd
                classes={classes}
                faq={faq}
                siteId={site.id}
                handleClick={handleClick}
            />
        )

        return (
            <TableCell className={classes.tableCell}>
            {faqTranslation === null ?
                <AddTranslationButton />
            :
                <span id="buttons">
                    <FaqTranslationsTableItemActionEdit
                        classes={classes}
                        faq={faq}
                        faqTranslation={faqTranslation}
                    />
                    <DeleteTranslationButton/>
                </span>
            }
            </TableCell>
        )
    }
};

export default FaqTranslationsTableItemActions;


// WEBPACK FOOTER //
// ./src/containers/faqs/translations/FaqTranslationsTableItemActions.jsx